import React from "react";
import { Container, Grid, Link } from "@mui/material";
import Heading from "../../components/Heading/heading";

import welcomimg from "../../image/welcomimg.png";

const Welcome = () => {
    return(
        <Container maxWidth="lg" className="py-5">
            <Grid
                container
                justifyContent="flex-start"
                alignItems="center"
            >
                <Grid
                    xs={12}
                    sm={5}
                    className="text-right d-none d-sm-inline-block"
                >
                    <img src={welcomimg} className="img-fluid w-100 mb-4 mb-sm-0" style={{maxWidth:300}} />
                </Grid>
                <Grid
                    xs={12}
                    sm={7}
                    className="pl-sm-5"
                >
                    <Heading
                        subtitle="Welcome"
                        title="Puppy Dog Community Protocol"
                    />
                    <p>ShibaPup is a BSC long term token built on Binance Smart Chain focused in the dog driven community, we all are Pup lovers!</p>
                    <Link href="https://t.me/shibapupdog" className="Global---menu-nav-btn px-3 py-2 mt-3 d-inline-block btn">Join Telegram Community</Link>
                </Grid>
                <Grid
                    xs={12}
                    sm={5}
                    className="text-center d-sm-none"
                >
                    <img src={welcomimg} className="img-fluid w-100 mt-5 mb-sm-0" style={{maxWidth:300}} />
                </Grid>
            </Grid>
        </Container>
    )
}

export default Welcome;